import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import ServerSideAgGrid, { useGridServerSideDataSource } from '@tls/ui-server-side-aggrid';

import AgGrid from '../../../shared/displayComponents/agGrid/agGrid.component';

import { columnDefinitions } from './importDataGrid.columnDefinitions';
import styles from './importDataGrid.module.scss';

const rowClassRules = {
  'import-grid__row--error': ({ data }) =>
    data?.importStatus === 'Failed' ||
    data?.importStatus === 'Failure' ||
    Boolean(data?.errorMessage),
};

const parseRowCount = total => {
  if (typeof total === 'number' && Number.isFinite(total)) {
    return total;
  }

  if (typeof total === 'string' && total.trim() !== '') {
    const parsedTotal = Number.parseInt(total, 10);

    return Number.isFinite(parsedTotal) ? parsedTotal : undefined;
  }

  return undefined;
};

const ImportDataGrid = ({ fetchLastImportDataPage, rowData = null, isGridLoading = false }) => {
  const { onGridReady } = useGridServerSideDataSource({
    fetchData: async ({ offset, sortModel }) => {
      const { data, total } = await fetchLastImportDataPage({
        offset,
        sort: sortModel,
      });
      const rowCount = parseRowCount(total);

      return {
        rowData: data,
        ...(rowCount !== undefined ? { rowCount } : {}),
      };
    },
  });

  const onServerSideGridReady = useCallback(
    params => {
      onGridReady(params);
    },
    [onGridReady],
  );

  return (
    <div className="row grid-row">
      <div className={`col ${styles.importGrid}`}>
        {rowData ? (
          <AgGrid
            columnDefs={columnDefinitions}
            rowData={rowData}
            rowClassRules={rowClassRules}
            isGridLoading={isGridLoading}
            autoMaxWidth
            withSearchBar
          />
        ) : (
          <ServerSideAgGrid
            columnDefs={columnDefinitions}
            onGridReady={onServerSideGridReady}
            rowClassRules={rowClassRules}
          />
        )}
      </div>
    </div>
  );
};

ImportDataGrid.propTypes = {
  fetchLastImportDataPage: PropTypes.func.isRequired,
  rowData: PropTypes.arrayOf(PropTypes.object),
  isGridLoading: PropTypes.bool,
};

export default memo(ImportDataGrid);
